const baseURL = 'https://markabelle.com/';

export default baseURL;
